import { render, staticRenderFns } from "./ModalFramePage.vue?vue&type=template&id=fc82a02e&scoped=true"
import script from "./ModalFramePage.vue?vue&type=script&lang=ts"
export * from "./ModalFramePage.vue?vue&type=script&lang=ts"
import style0 from "./ModalFramePage.vue?vue&type=style&index=0&id=fc82a02e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc82a02e",
  null
  
)

export default component.exports